import io from 'socket.io-client';
import environment from '../environment';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
    this.connected = false;
  }

  connect(token) {
    if (this.socket?.connected) return;

    const apiUrl = environment.api.replace(/\/$/, '');

    this.socket = io(apiUrl, {
      transports: ['websocket', 'polling'],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
    });

    this.socket.on('connect', () => {
      console.log('[Socket] Connected');
      this.connected = true;

      // Authenticate after connection
      this.socket.emit('authenticate', { token }, (response) => {
        if (response?.success) {
          console.log('[Socket] Authenticated as', response.userId);
        } else {
          console.warn('[Socket] Auth failed:', response?.error);
        }
      });
    });

    this.socket.on('disconnect', (reason) => {
      console.log('[Socket] Disconnected:', reason);
      this.connected = false;
    });

    this.socket.on('reconnect', () => {
      console.log('[Socket] Reconnected, re-authenticating...');
      this.socket.emit('authenticate', { token });
    });

    this.socket.on('connect_error', (err) => {
      console.warn('[Socket] Connection error:', err.message);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
      this.listeners.clear();
    }
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
      // Track listeners for cleanup
      if (!this.listeners.has(event)) {
        this.listeners.set(event, []);
      }
      this.listeners.get(event).push(callback);
    }
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.removeListener(event, callback);
    }
  }

  emit(event, data, cb) {
    if (this.socket?.connected) {
      this.socket.emit(event, data, cb);
    }
  }

  joinLoadRoom(loadId) {
    this.emit('join-load', { loadId });
  }

  leaveLoadRoom(loadId) {
    this.emit('leave-load', { loadId });
  }

  isConnected() {
    return this.connected && this.socket?.connected;
  }
}

// Singleton instance
const socketService = new SocketService();
export default socketService;
